import { isNil } from 'lodash';

export function getBool(key: string, defaultValue: boolean): boolean {
  if (key in process.env) {
    const val = process.env[key];

    if (isNil(val)) {
      return defaultValue;
    }

    if (val.toLowerCase() === 'true') {
      return true;
    }
    if (val.toLowerCase() === 'false') {
      return false;
    }
  }
  return defaultValue;
}

export function getNumber(
  key: string,
  defaultValue: number | null = null
): number {
  if (key in process.env) {
    const val = Number(process.env[key]);

    if (isNaN(val)) {
      return defaultValue ?? 0;
    }
    return val;
  }
  return defaultValue ?? 0;
}
